export default "__VITE_ASSET__c0be17f1__"